import Swiper, {Navigation} from "swiper";

// Kroki zasad są sliderem TYLKO na mobile — na desktopie .rules-row zostaje gridem 4 × 1
// (patrz assets/styles/sections/s-rules.scss). Swipera nie da się więc tylko skonfigurować
// breakpointami: trzeba go tworzyć i niszczyć przy zmianie szerokości, bo `enabled: false`
// zostawiłoby na slajdach inline'owe szerokości i rozwaliło grid.
$(function () {
    const slider = $('.rules-slider')[0];

    if (!slider) {
        return;
    }

    // 767.98px = górna granica bootstrapowego `media-breakpoint-down(md)`.
    const mobile = window.matchMedia('(max-width: 767.98px)');
    let swiper = null;

    const sync = () => {
        if (mobile.matches && !swiper) {
            swiper = new Swiper(slider, {
                slidesPerView: 1,
                // Odstęp między kaflami musi iść przez Swipera (dokłada go do szerokości slajdu),
                // a nie przez gap/gutter'y — te rozjeżdżałyby kadr.
                spaceBetween: 24,
                // Jak w sliderze produktów: zawijanie na strzałkach bez klonów slajdów.
                rewind: true,
                navigation: {
                    prevEl: $('.rules-carousel .swiper-button-prev')[0],
                    nextEl: $('.rules-carousel .swiper-button-next')[0]
                },
                modules: [Navigation]
            });
        } else if (!mobile.matches && swiper) {
            // true, true → zdejmij inline'owe style i klasy Swipera, żeby grid wrócił bez śladów.
            swiper.destroy(true, true);
            swiper = null;
        }
    };

    sync();
    mobile.addEventListener('change', sync);
});
